import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  TextInput,
  ScrollView,
  FlatList,
  Linking,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import Modal from "modal-enhanced-react-native-web";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import moment from "moment";
import { timeformet } from "../../component/format";
import { getevent } from "../../action/actionGet";
import { useIsFocused } from "@react-navigation/native";
const { width, height } = Dimensions.get("window");

export const charec = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "o",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
];

const shirtSizes = ["ไม่ต้องการ", "XS", "S", "M", "L", "XL", "XXL", "3XL"];
const vipOptions = [
  { label: "VIP", value: true },
  { label: "Normal", value: false },
];
const bibPremiumOptions = [
  { label: "Bib Premium", value: true },
  { label: "Bib Normal", value: false },
];

export default function payment({ navigation, route }) {
  const user = route?.params;
  const token = useRecoilValue(tokenState);
  const [data, setdata] = useState([]);
  const [dataDe, setdataDe] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleADD, setmodalVisibleADD] = useState(false);
  const [modalEditVisible, setmodalEditVisible] = useState(false);
  const [selecttype, setSelecttype] = useState(false);
  const [selecttype1, setSelecttype1] = useState(false);
  const [selecttype2, setSelecttype2] = useState(false);
  const [selecttype3, setSelecttype3] = useState(false);
  const [selecttype4, setSelecttype4] = useState(false);
  const [selecttype5, setSelecttype5] = useState(false);
  const [selectVipAdd, setSelectVipAdd] = useState(false);
  const [selectBibPremiumAdd, setSelectBibPremiumAdd] = useState(false);
  const [selectVipEdit, setSelectVipEdit] = useState(false);
  const [selectBibPremiumEdit, setSelectBibPremiumEdit] = useState(false);
  const [selectTagEdit, setSelectTagEdit] = useState(false);
  const [event, setevent] = useState([]);
  const [distance, setdistance] = useState([]);
  const [tag, setTag] = useState([]);
  const [BIB, setBIB] = useState([]);
  const [body, setbody] = useState({});
  const isFocus = useIsFocused();

  useEffect(() => {
    getHistorymok();
    allevent();
  }, [isFocus]);

  async function allevent() {
    const get = await getevent(token);
    if (get.status == 200) {
      setevent(get.data.data);
    }
  }

  async function getHistorymok() {
    setdata([]);
    const response = await apiservice({
      path: "/event/getallmockpayment/" + user.id,
      token: token.accessToken,
    });
    if (response.status == 200) {
      setdata((val) =>
        val.concat(response.data.data?.filter((e) => !e?.mission_id)),
      );
      setdata((val) =>
        val.concat(uniqeKeep(response.data.data, (it) => it?.mission_id)),
      );
    }
  }

  const uniqeKeep = (data, key) => {
    return [
      ...new Map(
        data?.filter((e) => e?.mission_id).map((x) => [key(x), x]),
      ).values(),
    ];
  };

  const resolveBibUrlFromCurrentEvent = (payload = {}) => {
    const currentEventId = payload?.event_id ?? payload?.eventId;
    const currentPackageId = payload?.package_id ?? payload?.packageId;
    const currentEvent = event?.find(
      (item) => String(item?.id) === String(currentEventId),
    );
    const currentPackage = currentEvent?.distances?.find(
      (item) => String(item?.id) === String(currentPackageId),
    );

    if (currentPackage) {
      return payload?.isBIBVIP
        ? currentPackage?.img_pre
        : currentPackage?.img_basic;
    }

    if (payload?.biburl) {
      return payload?.biburl;
    }

    return payload?.isBIBVIP === true ? BIB?.img_pre : BIB?.img_basic;
  };

  const resolvePayStatusFromCurrentEvent = (payload = {}) => {
    const currentEventId = payload?.event_id ?? payload?.eventId;
    const currentPackageId = payload?.package_id ?? payload?.packageId;
    const currentEvent = event?.find(
      (item) => String(item?.id) === String(currentEventId),
    );
    const packages = currentEvent?.distances ?? currentEvent?.distance ?? [];
    const currentPackage = packages?.find(
      (item) => String(item?.id) === String(currentPackageId),
    );

    if (currentPackage) {
      const isVipPackage =
        payload?.isPremium === true || payload?.isPremium === "Vip";
      return isVipPackage
        ? currentPackage?.premiumPrice
        : currentPackage?.price;
    }

    if (payload?.price != null) {
      return payload?.price;
    }

    return payload?.pay_status ?? 0;
  };

  const updateResult = async (id, distance, running_Time) => {
    const res = await apiservice({
      path: "/event/updateuserjoinEvent2",
      method: "put",
      body: {
        id: id,
        distance: distance,
        bib: body?.bib,
        running_Time: minutesAndSecondsToSeconds(running_Time),
        fullAddress: {
          ...body?.fullAddress,
          size: body?.shirt_size || user?.full_address?.size,
        },
        biburl: resolveBibUrlFromCurrentEvent(body),
        VIP_Status: body?.VIP_Status ?? false,
        isPremium: body?.isPremium ?? false,
        isBIBVIP: body?.isBIBVIP ?? false,
        tag: body?.tag,
        pay_status: resolvePayStatusFromCurrentEvent(body),
      },
      token: token.accessToken,
    });

    if (res.status == 200) {
      getHistorymok();
      setmodalEditVisible(false);
    }
  };

  const checkBib = async (index = 0) => {
    if (body?.bib.length > 4) {
      alert("เลขบิบต้องไม่เกิน 4 หลัก");
      return;
    }

    const i = index || 0;

    const check = await apiservice({
      path: "/event/postbib_event",
      method: "post",
      body: {
        event_id: body?.event_id, //eventId
        bib: body?.bib.toString(), //เลขบิบ
        number: parseInt(body?.bib), //เลขบิบ
        char: charec?.[i] + body?.bib, //เลขบิบ
      },
      token: token.accessToken,
    });

    if (check?.status == 200) {
      const resposne = await apiservice({
        path: "/event/postjoinEvent",
        method: "post",
        body: {
          event_id: body?.event_id,
          tag: body.tag ?? "ทั่วไป",
          packageId: body.packageId,
          package_id: body.package_id,
          img_event: body.img_title,
          event_name: body?.event_name,
          Type: "EVENT",
          uid: user.id,
          total_distance: body?.newdistance * 1000,
          last_distance: 0,
          reward_Info: body?.reward,
          fullAddress: {
            ...body?.fullAddress,
            size: body?.shirt_size || body?.fullAddress?.size,
          },
          tracking: "",
          bib: charec?.[i] + body?.bib,
          biburl: resolveBibUrlFromCurrentEvent(body),
          pay_status: resolvePayStatusFromCurrentEvent(body),
          VIP_Status: body?.VIP_Status ?? false,
          isPremium: body?.isPremium ?? false,
          isBIBVIP: body?.isBIBVIP ?? false,
        },
        token: token.accessToken,
      });

      if (resposne.status == 200) {
        getHistorymok();
        setmodalVisibleADD(false);
      } else {
        checkBib(i + 1);
      }
    } else {
      checkBib(i + 1);
    }
  };

  const secondsToMinutesAndSeconds = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // TODO: แก้ไขให้เป็น 2 ตำแหน่ง
    const sec =
      remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
    const min = minutes < 10 ? `0${minutes}` : minutes;

    return parseFloat(`${min}.${sec}`).toFixed(2);
  };

  const minutesAndSecondsToSeconds = (minutes) => {
    let seconds = 0;
    let minute = 0;

    if (minutes.includes(".")) {
      minute = parseInt(minutes.split(".")[0]);
      seconds = parseInt(minutes.split(".")[1]);
    } else {
      minute = minutes;
    }

    return minute * 60 + seconds;
  };

  return (
    <View style={styles.container}>
      <Modal isVisible={modalVisible}>
        <View style={styles.modalOverlay}>
          <ScrollView>
            <View style={styles.modalBoxSmall}>
              <View style={styles.modalBoxInner}>
                <Text style={styles.modalTitle}>
                  ต้องการที่จะลบ Event ใช่หรือไม่
                </Text>

                <View style={styles.modalActionsRow}>
                  <TouchableOpacity
                    onPress={() => {
                      setModalVisible((val) => !val);
                    }}
                    style={styles.modalBtnSmall}
                  >
                    <Text style={styles.modalBtnSmallText}>ยกเลิก</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={async () => {
                      console.log(dataDe);
                      const response = await apiservice({
                        method: "get",
                        path: "/event/delete/user/event/" + dataDe?.id,
                      });
                      console.log(response.data);
                      if (response.status == 200) {
                        getHistorymok();
                        setModalVisible((val) => !val);
                      }
                    }}
                    style={styles.modalBtnSmall}
                  >
                    <Text style={styles.modalBtnSmallText}>ตกลง</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
      </Modal>

      <Modal isVisible={modalVisibleADD}>
        <View style={styles.modalOverlay}>
          <ScrollView
            contentContainerStyle={styles.modalScrollContent}
            showsVerticalScrollIndicator={false}
          >
            <View style={styles.modalBoxLarge}>
              <View style={styles.modalBoxInnerLarge}>
                <Text style={styles.modalHeading}>ADD event</Text>
                {body?.fullAddress && (
                  <View style={styles.fullAddressContainer}>
                    <Text style={styles.fullAddressLabel}>
                      ที่อยู่การจัดส่ง
                    </Text>
                    <TextInput
                      value={body?.fullAddress?.ShippingAddress || ""}
                      onChangeText={(text) =>
                        setbody((prev) => ({
                          ...prev,
                          fullAddress: {
                            ...(prev.fullAddress || {}),
                            ShippingAddress: text,
                          },
                        }))
                      }
                      style={styles.inputLarge}
                      placeholder="ที่อยู่"
                    />
                    <View style={styles.fullAddressRow}>
                      <TextInput
                        value={body?.fullAddress?.subDistrict || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              subDistrict: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="ตำบล"
                      />
                      <TextInput
                        value={body?.fullAddress?.district || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              district: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="อำเภอ"
                      />
                      <TextInput
                        value={body?.fullAddress?.province || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              province: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="จังหวัด"
                      />
                    </View>
                    <View style={styles.fullAddressRow}>
                      <TextInput
                        value={
                          body?.fullAddress?.postcode
                            ? String(body.fullAddress.postcode)
                            : ""
                        }
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              postcode: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "48%" }]}
                        placeholder="รหัสไปรษณีย์"
                        keyboardType="numeric"
                      />
                      <TextInput
                        value={body?.fullAddress?.telnum || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              telnum: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "48%" }]}
                        placeholder="เบอร์โทร"
                        keyboardType="phone-pad"
                      />
                    </View>
                  </View>
                )}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    zIndex: 2,
                    marginVertical: 20,
                  }}
                >
                  <View style={styles.col48}>
                    <TouchableOpacity
                      onPress={() => {
                        setSelecttype(true);
                        setSelecttype1(false);
                        setSelecttype2(false);
                        setSelecttype3(false);
                        setSelectVipAdd(false);
                        setSelectBibPremiumAdd(false);
                      }}
                      style={[styles.Down1, styles.fullWidth]}
                    >
                      <Text numberOfLines={1} style={styles.textMuted}>
                        {body?.event_name ? body?.event_name : "เลือก EVENT"}
                      </Text>
                    </TouchableOpacity>
                    {selecttype && (
                      <View style={styles?.Down}>
                        <FlatList
                          data={event}
                          style={{ height: 200 }}
                          renderItem={({ index, item }) => {
                            return (
                              <TouchableOpacity
                                onPress={() => {
                                  setdistance(item?.distances);
                                  setTag(item?.tag);
                                  setbody({
                                    ...body,
                                    event_name: item?.titel,
                                    event_id: item?.id,
                                    reward: item?.reward,
                                    img_title: item?.img_title,
                                  });

                                  setSelecttype(false);
                                  setSelecttype1(true);
                                  setSelecttype3(false);
                                }}
                                style={styles.itemPadding}
                              >
                                <Text
                                  numberOfLines={1}
                                  style={styles.textSecondary}
                                >
                                  {item?.titel}
                                </Text>
                              </TouchableOpacity>
                            );
                          }}
                        />
                      </View>
                    )}
                  </View>
                  <View style={styles.col48}>
                    <TouchableOpacity
                      onPress={() => {
                        if (!distance?.length) return;
                        setSelecttype1(true);
                        setSelecttype(false);
                        setSelecttype2(false);
                        setSelecttype3(false);
                        setSelectVipAdd(false);
                        setSelectBibPremiumAdd(false);
                      }}
                      style={[styles?.Down1, { width: "100%" }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.distance ? body?.distance : "ระยะทาง EVENT"}
                      </Text>
                    </TouchableOpacity>
                    {selecttype1 && (
                      <View style={styles?.Down}>
                        <FlatList
                          data={distance}
                          style={{ height: 200 }}
                          renderItem={({ index, item }) => {
                            return (
                              <TouchableOpacity
                                onPress={() => {
                                  setBIB(item);
                                  setbody({
                                    ...body,
                                    distance: item?.title,
                                    newdistance: item?.distance,
                                    packageId: item?.id,
                                    package_id: item?.id,
                                  });
                                  setSelecttype1(false);
                                  setSelecttype2(true);
                                  setSelecttype3(false);
                                }}
                                style={styles.itemPadding}
                              >
                                <Text style={styles.textSecondary}>
                                  {item?.title}
                                </Text>
                              </TouchableOpacity>
                            );
                          }}
                        />
                      </View>
                    )}
                  </View>
                </View>
                <View style={{ marginVertical: 20, width: "48%" }}>
                  <TouchableOpacity
                    onPress={() => {
                      setSelecttype2(true);
                      setSelecttype3(false);
                      setSelectVipAdd(false);
                      setSelectBibPremiumAdd(false);
                    }}
                    style={[styles.Down1, styles.fullWidth]}
                  >
                    <Text style={styles.textMuted}>
                      {body?.VIP_Status ? "VIP" : "BASIC"}
                    </Text>
                  </TouchableOpacity>
                  {selecttype2 && (
                    <View style={styles?.Down}>
                      <FlatList
                        data={["VIP", "BASIC"]}
                        style={{ height: 100 }}
                        renderItem={({ index, item }) => {
                          return (
                            <TouchableOpacity
                              onPress={() => {
                                if (item == "VIP") {
                                  setbody({
                                    ...body,
                                    price: BIB?.price,
                                    biburl: BIB?.img_pre,
                                    VIP_Status: true,
                                  });
                                  setSelecttype2(false);
                                } else {
                                  setbody({
                                    ...body,
                                    price: BIB?.price,
                                    biburl: BIB?.img_basic,
                                    VIP_Status: false,
                                  });
                                  setSelecttype2(false);
                                }
                              }}
                              style={styles.itemPadding}
                            >
                              <Text style={styles.textSecondary}>{item}</Text>
                            </TouchableOpacity>
                          );
                        }}
                      />
                    </View>
                  )}
                </View>
                <Text style={styles.fieldLabel}>เลข BIB</Text>
                <TextInput
                  maxLength={6}
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      bib: text,
                    });
                  }}
                  style={styles.input}
                />

                <Text style={styles.fieldLabel}>Tag</Text>
                <View style={{ width: "100%", zIndex: 4 }}>
                  <TouchableOpacity
                    onPress={() => {
                      if (!body?.event_name) return;
                      setSelecttype5(!selecttype5);
                    }}
                    style={[
                      styles?.Down1,
                      { width: "100%", opacity: body?.event_name ? 1 : 0.4 },
                    ]}
                  >
                    <Text numberOfLines={1} style={styles.textMuted}>
                      {body?.tag ? body?.tag : "เลือก"}
                    </Text>
                  </TouchableOpacity>
                  {selecttype5 && (
                    <View style={styles?.Down}>
                      <FlatList
                        data={tag}
                        style={{ height: 200 }}
                        renderItem={({ index, item }) => {
                          return (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({
                                  ...body,
                                  tag: item,
                                });
                                setSelecttype5(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text
                                numberOfLines={1}
                                style={styles.textSecondary}
                              >
                                {item}
                              </Text>
                            </TouchableOpacity>
                          );
                        }}
                      />
                    </View>
                  )}
                </View>

                <Text style={styles.textLabelLarge}>ไซส์เสื้อ</Text>
                <View style={[styles.col48, { zIndex: 3 }]}>
                  <TouchableOpacity
                    onPress={() => {
                      setSelecttype3(true);
                      setSelecttype(false);
                      setSelecttype1(false);
                      setSelecttype2(false);
                      setSelectVipAdd(false);
                      setSelectBibPremiumAdd(false);
                    }}
                    style={[styles.Down1, styles.fullWidth, { height: 40 }]}
                  >
                    <Text style={styles.textMuted}>
                      {body?.shirt_size ? body?.shirt_size : "เลือกไซส์เสื้อ"}
                    </Text>
                  </TouchableOpacity>
                  {selecttype3 && (
                    <View style={[styles?.Down, { marginTop: 40 }]}>
                      <FlatList
                        data={shirtSizes}
                        style={{ height: 140 }}
                        keyExtractor={(item) => item}
                        renderItem={({ item }) => {
                          return (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({
                                  ...body,
                                  shirt_size: item,
                                });
                                setSelecttype3(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text style={styles.textSecondary}>{item}</Text>
                            </TouchableOpacity>
                          );
                        }}
                      />
                    </View>
                  )}
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 12,
                    zIndex: 1,
                  }}
                >
                  <View style={styles.col48}>
                    <Text
                      style={{
                        fontSize: 18,
                        fontFamily: "Prompt-Regular",
                        marginBottom: 8,
                      }}
                    >
                      isVip
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelectVipAdd(true);
                        setSelectBibPremiumAdd(false);
                        setSelecttype(false);
                        setSelecttype1(false);
                        setSelecttype2(false);
                        setSelecttype3(false);
                      }}
                      style={[styles.Down1, styles.fullWidth, { height: 40 }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.isPremium ? "VIP" : "Normal"}
                      </Text>
                    </TouchableOpacity>
                    {selectVipAdd && (
                      <View style={[styles?.Down, { marginTop: 40 }]}>
                        <FlatList
                          data={vipOptions}
                          style={{ height: 80 }}
                          keyExtractor={(item) => item.label}
                          renderItem={({ item }) => (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({ ...body, isPremium: item.value });
                                setSelectVipAdd(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text style={styles.textSecondary}>
                                {item.label}
                              </Text>
                            </TouchableOpacity>
                          )}
                        />
                      </View>
                    )}
                  </View>

                  <View style={styles.col48}>
                    <Text style={styles.textLabelSmall}>bibPremium</Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelectBibPremiumAdd(true);
                        setSelectVipAdd(false);
                        setSelecttype(false);
                        setSelecttype1(false);
                        setSelecttype2(false);
                        setSelecttype3(false);
                      }}
                      style={[styles.Down1, styles.fullWidth, { height: 40 }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.isBIBVIP ? "Bib Premium" : "Bib Normal"}
                      </Text>
                    </TouchableOpacity>
                    {selectBibPremiumAdd && (
                      <View style={[styles?.Down, { marginTop: 40 }]}>
                        <FlatList
                          data={bibPremiumOptions}
                          style={{ height: 80 }}
                          keyExtractor={(item) => item.label}
                          renderItem={({ item }) => (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({ ...body, isBIBVIP: item.value });
                                setSelectBibPremiumAdd(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text style={styles.textSecondary}>
                                {item.label}
                              </Text>
                            </TouchableOpacity>
                          )}
                        />
                      </View>
                    )}
                  </View>
                </View>
                <View style={styles.modalActionsRowLarge}>
                  <TouchableOpacity
                    onPress={() => {
                      setmodalVisibleADD(false);
                      setSelecttype3(false);
                      setSelectVipAdd(false);
                      setSelectBibPremiumAdd(false);
                    }}
                    style={styles.modalBtnLarge}
                  >
                    <Text style={styles.modalBtnLargeText}>ยกเลิก</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      setSelecttype3(false);
                      setSelectVipAdd(false);
                      setSelectBibPremiumAdd(false);
                      checkBib(0);
                    }}
                    style={styles.modalBtnLarge}
                  >
                    <Text style={styles.modalBtnLargeText}>ตกลง</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
      </Modal>

      <Modal isVisible={modalEditVisible}>
        <View style={styles.modalOverlay}>
          <ScrollView
            contentContainerStyle={styles.modalScrollContent}
            showsVerticalScrollIndicator={false}
          >
            <View style={styles.modalBoxLarge}>
              <View style={styles.modalBoxInnerLarge}>
                <Text style={styles.modalHeading}>Edit event</Text>
                {body?.fullAddress && (
                  <View style={styles.fullAddressContainer}>
                    <Text style={styles.fullAddressLabel}>
                      ที่อยู่การจัดส่ง
                    </Text>
                    <TextInput
                      value={body?.fullAddress?.ShippingAddress || ""}
                      onChangeText={(text) =>
                        setbody((prev) => ({
                          ...prev,
                          fullAddress: {
                            ...(prev.fullAddress || {}),
                            ShippingAddress: text,
                          },
                        }))
                      }
                      style={styles.inputLarge}
                      placeholder="ที่อยู่"
                    />
                    <View style={styles.fullAddressRow}>
                      <TextInput
                        value={body?.fullAddress?.subDistrict || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              subDistrict: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="ตำบล"
                      />
                      <TextInput
                        value={body?.fullAddress?.district || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              district: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="อำเภอ"
                      />
                      <TextInput
                        value={body?.fullAddress?.province || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              province: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "32%" }]}
                        placeholder="จังหวัด"
                      />
                    </View>
                    <View style={styles.fullAddressRow}>
                      <TextInput
                        value={
                          body?.fullAddress?.postcode
                            ? String(body.fullAddress.postcode)
                            : ""
                        }
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              postcode: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "48%" }]}
                        placeholder="รหัสไปรษณีย์"
                        keyboardType="numeric"
                      />
                      <TextInput
                        value={body?.fullAddress?.telnum || ""}
                        onChangeText={(text) =>
                          setbody((prev) => ({
                            ...prev,
                            fullAddress: {
                              ...(prev.fullAddress || {}),
                              telnum: text,
                            },
                          }))
                        }
                        style={[styles.input, { width: "48%" }]}
                        placeholder="เบอร์โทร"
                        keyboardType="phone-pad"
                      />
                    </View>
                  </View>
                )}
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    zIndex: 2,
                  }}
                >
                  <View style={styles.col48}>
                    <Text style={styles.textLabelLarge}>EVENT</Text>
                    <TouchableOpacity
                      disabled
                      onPress={() => {
                        setSelecttype(true);
                        setSelecttype1(false);
                        setSelecttype2(false);
                        setSelecttype4(false);
                      }}
                      style={[styles.Down1, styles.fullWidth]}
                    >
                      <Text numberOfLines={1} style={styles.textMuted}>
                        {body?.event_name ? body?.event_name : "เลือก EVENT"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                  <View style={{ width: "48%" }}>
                    <Text style={styles.textLabelLarge}>ระยะทาง EVENT1</Text>
                    <TouchableOpacity
                      disabled
                      style={[styles.Down1, styles.fullWidth]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.distance
                          ? `${body?.distance / 1000} km`
                          : "ระยะทาง EVENT"}
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    zIndex: 5,
                  }}
                >
                  <View style={{ width: "48%", zIndex: 3 }}>
                    <Text style={styles.textLabelLarge}>ไซส์เสื้อ</Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelecttype4(true);
                        setSelectVipEdit(false);
                        setSelectBibPremiumEdit(false);
                        setSelectTagEdit(false);
                      }}
                      style={[styles.Down1, styles.fullWidth, { height: 50 }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.shirt_size ? body?.shirt_size : "เลือกไซส์เสื้อ"}
                      </Text>
                    </TouchableOpacity>
                    {selecttype4 && (
                      <View style={[styles?.Down, { marginTop: 50 }]}>
                        <FlatList
                          data={shirtSizes}
                          style={{ height: 140 }}
                          keyExtractor={(item) => item}
                          renderItem={({ item }) => {
                            return (
                              <TouchableOpacity
                                onPress={() => {
                                  setbody({
                                    ...body,
                                    shirt_size: item,
                                  });
                                  setSelecttype4(false);
                                }}
                                style={styles.itemPadding}
                              >
                                <Text style={styles.textSecondary}>{item}</Text>
                              </TouchableOpacity>
                            );
                          }}
                        />
                      </View>
                    )}
                  </View>

                  <View style={{ width: "48%" }}>
                    <Text style={styles.textLabelLarge}>สถานะ</Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelecttype2(true);
                        setSelecttype3(false);
                        setSelectVipAdd(false);
                        setSelectBibPremiumAdd(false);
                      }}
                      style={[styles.Down1, styles.fullWidth]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.VIP_Status ? "VIP" : "BASIC"}
                      </Text>
                    </TouchableOpacity>
                    {selecttype2 && (
                      <View style={styles?.Down}>
                        <FlatList
                          data={["VIP", "BASIC"]}
                          style={{ height: 100 }}
                          renderItem={({ index, item }) => {
                            return (
                              <TouchableOpacity
                                onPress={() => {
                                  if (item == "VIP") {
                                    setbody({
                                      ...body,
                                      price: BIB?.price,
                                      biburl: BIB?.img_pre,
                                      VIP_Status: true,
                                    });
                                    setSelecttype2(false);
                                  } else {
                                    setbody({
                                      ...body,
                                      price: BIB?.price,
                                      biburl: BIB?.img_basic,
                                      VIP_Status: false,
                                    });
                                    setSelecttype2(false);
                                  }
                                }}
                                style={styles.itemPadding}
                              >
                                <Text style={styles.textSecondary}>{item}</Text>
                              </TouchableOpacity>
                            );
                          }}
                        />
                      </View>
                    )}
                  </View>
                </View>

                <Text style={styles.textLabelLarge}>Tag</Text>
                <View style={{ width: "48%", zIndex: 4 }}>
                  <TouchableOpacity
                    onPress={() => {
                      setSelectTagEdit(!selectTagEdit);
                      setSelecttype4(false);
                      setSelectVipEdit(false);
                      setSelectBibPremiumEdit(false);
                    }}
                    style={[styles.Down1, styles.fullWidth, { height: 50 }]}
                  >
                    <Text style={styles.textMuted}>
                      {body?.tag ? body?.tag : "เลือก"}
                    </Text>
                  </TouchableOpacity>
                  {selectTagEdit && (
                    <View style={[styles?.Down, { marginTop: 50 }]}>
                      <FlatList
                        data={tag}
                        style={{ height: 200 }}
                        keyExtractor={(item) => item}
                        renderItem={({ item }) => (
                          <TouchableOpacity
                            onPress={() => {
                              setbody({ ...body, tag: item });
                              setSelectTagEdit(false);
                            }}
                            style={styles.itemPadding}
                          >
                            <Text style={styles.textSecondary}>{item}</Text>
                          </TouchableOpacity>
                        )}
                      />
                    </View>
                  )}
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: 12,
                    zIndex: 2,
                  }}
                >
                  <View style={{ width: "48%" }}>
                    <Text
                      style={{
                        fontSize: 18,
                        fontFamily: "Prompt-Regular",
                        marginBottom: 8,
                      }}
                    >
                      isVip
                    </Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelectVipEdit(true);
                        setSelectBibPremiumEdit(false);
                        setSelecttype4(false);
                        setSelectTagEdit(false);
                      }}
                      style={[styles.Down1, styles.fullWidth, { height: 50 }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.isPremium ? "VIP" : "Normal"}
                      </Text>
                    </TouchableOpacity>
                    {selectVipEdit && (
                      <View style={[styles?.Down, { marginTop: 50 }]}>
                        <FlatList
                          data={vipOptions}
                          style={{ height: 80 }}
                          keyExtractor={(item) => item.label}
                          renderItem={({ item }) => (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({ ...body, isPremium: item.value });
                                setSelectVipEdit(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text style={styles.textSecondary}>
                                {item.label}
                              </Text>
                            </TouchableOpacity>
                          )}
                        />
                      </View>
                    )}
                  </View>

                  <View style={{ width: "48%" }}>
                    <Text style={styles.textLabelSmall}>bibPremium</Text>
                    <TouchableOpacity
                      onPress={() => {
                        setSelectBibPremiumEdit(true);
                        setSelectVipEdit(false);
                        setSelecttype4(false);
                        setSelectTagEdit(false);
                      }}
                      style={[styles.Down1, styles.fullWidth, { height: 50 }]}
                    >
                      <Text style={styles.textMuted}>
                        {body?.isBIBVIP ? "Bib Premium" : "Bib Normal"}
                      </Text>
                    </TouchableOpacity>
                    {selectBibPremiumEdit && (
                      <View style={[styles?.Down, { marginTop: 50 }]}>
                        <FlatList
                          data={bibPremiumOptions}
                          style={{ height: 80 }}
                          keyExtractor={(item) => item.label}
                          renderItem={({ item }) => (
                            <TouchableOpacity
                              onPress={() => {
                                setbody({ ...body, isBIBVIP: item.value });
                                setSelectBibPremiumEdit(false);
                              }}
                              style={styles.itemPadding}
                            >
                              <Text
                                style={{
                                  fontSize: 18,
                                  fontFamily: "Prompt-Regular",
                                  color: "#00000080",
                                }}
                              >
                                {item.label}
                              </Text>
                            </TouchableOpacity>
                          )}
                        />
                      </View>
                    )}
                  </View>
                </View>
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                    marginVertical: 10,
                  }}
                >
                  เลข BIB
                </Text>
                <TextInput
                  maxLength={6}
                  defaultValue={body?.bib}
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      bib: text,
                    });
                  }}
                  style={styles.inputLarge}
                />
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                    marginVertical: 10,
                  }}
                >
                  ระยะวิ่ง (เมตร)
                </Text>
                <TextInput
                  maxLength={10}
                  defaultValue={body?.last_distance}
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      last_distance: text,
                    });
                  }}
                  style={styles.inputLarge}
                />
                <Text
                  style={{
                    fontSize: 18,
                    fontFamily: "Prompt-Regular",
                    marginVertical: 10,
                  }}
                >
                  เวลาที่ใช้ (นาที)
                </Text>
                <TextInput
                  maxLength={8}
                  defaultValue={body?.running_Time}
                  onChangeText={(text) => {
                    setbody({
                      ...body,
                      running_Time: text,
                    });
                  }}
                  style={styles.inputLarge}
                />
                <View style={styles.modalActionsRowLarge}>
                  <TouchableOpacity
                    onPress={() => {
                      setSelecttype4(false);
                      setSelectVipEdit(false);
                      setSelectBibPremiumEdit(false);
                      setSelectTagEdit(false);
                      setmodalEditVisible(false);
                    }}
                    style={styles.modalBtnLarge}
                  >
                    <Text style={styles.modalBtnLargeText}>ยกเลิก</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      setSelecttype4(false);
                      setSelectVipEdit(false);
                      setSelectBibPremiumEdit(false);
                      setSelectTagEdit(false);
                      updateResult(
                        body.id,
                        body.last_distance,
                        body.running_Time,
                        body.shirt_size,
                        body.isPremium,
                        body.isBIBVIP,
                        body.tag,
                        body.bib,
                      );
                    }}
                    style={styles.modalBtnLarge}
                  >
                    <Text style={styles.modalBtnLargeText}>ตกลง</Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          </ScrollView>
        </View>
      </Modal>

      <Dawer navigation={navigation} />
      <ScrollView>
        <View style={styles.back}>
          <Admin />
          <View style={styles.viewfree}>
            <Text style={styles.textfree}>
              USER{" "}
              <Text style={styles.textfree1}>
                / <Text style={styles.textfree1}>Event</Text>
              </Text>
            </Text>
            <View style={{ flexDirection: "row" }}>
              <TouchableOpacity
                onPress={() =>
                  navigation.navigate("ProflieUser", { item: route.params })
                }
                style={[styles.touchadd, { backgroundColor: "#fff" }]}
              >
                <Text style={styles.textadd}>PROFILE</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={() => {
                  setmodalVisibleADD(true);
                  setSelecttype(false);
                  setSelecttype1(false);
                  setSelecttype2(false);
                  setSelecttype3(false);
                  setSelectVipAdd(false);
                  setSelectBibPremiumAdd(false);
                  setbody({
                    shirt_size: user?.full_address?.size,
                    isPremium: false,
                    isBIBVIP: false,
                    fullAddress: user?.full_address || {},
                  });
                }}
                style={[
                  styles.touchadd,
                  { backgroundColor: "#FCC81D" },
                  { marginLeft: 10 },
                ]}
              >
                <Text style={styles.textadd}>ADD event</Text>
              </TouchableOpacity>
            </View>
          </View>
          <View style={styles.view}>
            <View style={styles.head}>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={[styles.texthead, { alignSelf: "center" }]}>
                  ออเดอร์
                </Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.2 }]}>
                <Text style={styles.texthead}>รายการ</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>วันที่ชำระเงิน</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>เวลา</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>สถานะ</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.1 }]}>
                <Text style={styles.texthead}>วิ่งไปแล้ว</Text>
              </View>
              <View style={[styles.viewhead, { width: width * 0.07 }]}>
                <Text style={styles.texthead}>ระยะทาง</Text>
              </View>
            </View>
            <FlatList
              data={data}
              renderItem={({ index, item }) => {
                return (
                  <TouchableOpacity
                    onPress={() => {
                      setbody({});
                      setmodalEditVisible(true);
                      setSelecttype4(false);
                      setSelectVipEdit(false);
                      setSelectBibPremiumEdit(false);
                      setSelectTagEdit(false);
                      const foundEvent = event?.find(
                        (e) => String(e?.id) === String(item?.event_id),
                      );
                      if (foundEvent) setTag(foundEvent?.tag || []);
                      setbody({
                        ...item,
                        distance: item?.total_distance,
                        shirt_size:
                          item?.fullAddress?.size || user?.full_address?.size,
                        isPremium: item?.isPremium ?? false,
                        isBIBVIP: item?.isBIBVIP ?? false,
                        running_Time: secondsToMinutesAndSeconds(
                          item?.running_Time,
                        ),
                      });
                    }}
                  >
                    <View
                      style={[styles.viewmain, { backgroundColor: "#fff" }]}
                    >
                      <View
                        style={[
                          {
                            width: width * 0.1,

                            justifyContent: "center",
                          },
                        ]}
                      >
                        <Text
                          style={[
                            styles.textdate,
                            {
                              alignSelf: "center",
                              textAlign: "center",
                            },
                          ]}
                        >
                          #{item.id + 10000}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.2 }]}>
                        <Text style={styles.textdate}>{item.event_name}</Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {moment(item.createdAt).format("DD-MMM-YYYY")}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {timeformet(
                            Math.floor(
                              item != undefined && item.running_Time / 3600,
                            ),
                          )}{" "}
                          :{" "}
                          {timeformet(
                            Math.floor(
                              (item != undefined && item.running_Time % 3600) /
                                60,
                            ),
                          )}{" "}
                          :{" "}
                          {timeformet(
                            Math.floor(
                              (item != undefined && item.running_Time % 3600) %
                                60,
                            ),
                          )}{" "}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text
                          style={[
                            styles.textdate,
                            {
                              color:
                                item?.last_distance >= item?.total_distance
                                  ? "#2DCE98"
                                  : "#FCC81D",
                              textAlign: "center",
                            },
                          ]}
                        >
                          {item?.last_distance >= item?.total_distance
                            ? "สำเร็จ"
                            : "กำลังวิ่ง"}
                        </Text>
                      </View>
                      <View style={[styles.viewdetail, { width: width * 0.1 }]}>
                        <Text style={styles.textdate}>
                          {item?.last_distance / 1000} กม.
                        </Text>
                      </View>
                      <View
                        style={[styles.viewdetail, { width: width * 0.07 }]}
                      >
                        <Text style={[styles.textdate]}>
                          {item?.total_distance / 1000} กม.
                        </Text>
                      </View>
                      <TouchableOpacity
                        onPress={() => {
                          setdataDe(item);
                          setModalVisible((val) => !val);
                        }}
                        style={[
                          styles.viewdetail,
                          {
                            width: width * 0.04,
                            height: 50,
                            justifyContent: "center",
                            alignItems: "center",
                          },
                        ]}
                      >
                        <Text style={[styles.textdate, { color: "#F88119" }]}>
                          ลบ
                        </Text>
                      </TouchableOpacity>
                    </View>
                  </TouchableOpacity>
                );
              }}
            />
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    width: width,
    height: height,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: width * 0.85,
    height: height,
    paddingHorizontal: width * 0.01,
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 180,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  textMuted: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#A1A1A1",
  },
  textSecondary: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#00000080",
  },
  textLabelLarge: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    marginVertical: 10,
  },
  textLabelSmall: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    marginBottom: 8,
  },
  head: {
    width: width * 0.828,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
  },
  viewhead: {
    paddingLeft: 10,
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
  },
  viewdetail: {
    flexDirection: "row",
  },
  img: {
    width: 39,
    height: 39,
    marginTop: 5,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
    marginLeft: 15,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
    marginLeft: 15,
  },
  viewmain: {
    flexDirection: "row",
    width: width,
    height: 50,
    paddingHorizontal: 5,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  view: {
    width: width * 0.83,
    height: "100%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 20,
    marginBottom: 20,
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "center",
    alignSelf: "center",
    width: "100%",
  },
  modalScrollContent: {
    flexGrow: 1,
    justifyContent: "center",
    paddingVertical: 24,
  },

  Down: {
    width: "100%",
    borderWidth: 1,
    borderColor: "#CCC",
    position: "absolute",
    marginTop: 50,
    zIndex: 99,
    backgroundColor: "#FFF",
  },
  Down1: {
    width: width * 0.27,
    height: 50,
    padding: 5,
    backgroundColor: "#C4C4C480",
    flexDirection: "row",
    paddingHorizontal: 10,
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: 3,
  },
  modalBoxSmall: {
    width: width * 0.42,
    height: 250,
    backgroundColor: "#FFF",
    borderRadius: 10,
    justifyContent: "center",
    alignSelf: "center",
  },
  modalBoxInner: {
    width: width * 0.37,
    height: 230,
    alignSelf: "center",
    justifyContent: "center",
  },
  modalTitle: {
    fontSize: 25,
    color: "black",
    fontFamily: "Prompt-Regular",
    textAlign: "center",
  },
  modalActionsRow: {
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 20,
  },
  modalBtnSmall: {
    width: 80,
    height: 28,
    backgroundColor: "#F88119",
    borderRadius: 5,
    marginHorizontal: 10,
    justifyContent: "center",
  },
  modalBtnSmallText: {
    fontFamily: "Prompt-Regular",
    fontSize: 13,
    marginLeft: 10,
    color: "#FFF",
    alignSelf: "center",
    textAlign: "center",
  },
  modalBoxLarge: {
    width: "92%",
    maxWidth: 820,
    backgroundColor: "#FFF",
    borderRadius: 10,
    paddingVertical: 24,
    alignSelf: "center",
  },
  modalBoxInnerLarge: {
    width: "88%",
    maxWidth: 720,
    alignSelf: "center",
  },
  modalHeading: {
    fontSize: 36,
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
  },
  fieldLabel: {
    fontSize: 18,
    fontFamily: "Prompt-Regular",
    marginTop: 10,
  },
  fullAddressContainer: {
    marginBottom: 10,
  },
  fullAddressLabel: {
    fontSize: 16,
    fontFamily: "Prompt-Regular",
    marginTop: 6,
  },
  fullAddressRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 8,
  },
  col48: {
    width: "48%",
  },
  fullWidth: {
    width: "100%",
  },
  itemPadding: {
    paddingHorizontal: 10,
  },
  input: {
    width: "48%",
    height: 40,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: "#00000080",
    padding: 5,
    fontFamily: "Prompt-Regular",
  },
  inputLarge: {
    width: "48%",
    height: 50,
    borderRadius: 3,
    borderWidth: 1,
    borderColor: "#00000080",
    padding: 5,
    fontFamily: "Prompt-Regular",
  },
  modalActionsRowLarge: {
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "center",
    marginTop: 25,
  },
  modalBtnLarge: {
    width: 180,
    height: 46,
    backgroundColor: "#F88119",
    borderRadius: 5,
    marginHorizontal: 10,
    justifyContent: "center",
  },
  modalBtnLargeText: {
    fontFamily: "Prompt-Regular",
    fontSize: 13,
    marginLeft: 10,
    color: "#FFF",
    alignSelf: "center",
  },
});
